
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/[[...index]]",
      function () {
        return require("private-next-pages/login/[[...index]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/[[...index]]"])
      });
    }
  